import { useState } from "react";
import Icon from "../../../components/AppIcon";
import { CodeSnippet } from "../types";

interface CodeSnippetShowcaseProps {
  snippets: CodeSnippet[];
}

const CodeSnippetShowcase = ({ snippets }: CodeSnippetShowcaseProps) => {
  const [activeSnippet, setActiveSnippet] = useState(0);

  return (
    <section className="py-20 bg-surface/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full mb-4">
            <Icon name="Terminal" size={18} color="var(--color-primary)" />
            <span className="text-sm font-mono text-primary">Code Samples</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Interactive Code Showcase
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore live code examples demonstrating clean, efficient programming practices
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap gap-2 mb-6">
            {snippets.map((snippet, index) => (
              <button
                key={snippet.id}
                onClick={() => setActiveSnippet(index)}
                className={`px-4 py-2 rounded-lg font-mono text-sm transition-all duration-300 ${
                  activeSnippet === index
                    ? "bg-primary text-primary-foreground shadow-elevation-2"
                    : "bg-surface text-muted-foreground hover:text-foreground hover:bg-muted"
                }`}
              >
                {snippet.language}
              </button>
            ))}
          </div>

          <div className="bg-[#0D1117] rounded-2xl overflow-hidden border border-border shadow-elevation-3">
            <div className="flex items-center justify-between px-6 py-4 bg-surface/50 border-b border-border">
              <div className="flex items-center gap-3">
                <div className="flex gap-2">
                  <div className="w-3 h-3 rounded-full bg-destructive"></div>
                  <div className="w-3 h-3 rounded-full bg-warning"></div>
                  <div className="w-3 h-3 rounded-full bg-success"></div>
                </div>
                <span className="text-sm font-mono text-muted-foreground">
                  {snippets[activeSnippet].title}
                </span>
              </div>
              <button className="p-2 hover:bg-muted rounded-lg transition-colors duration-300">
                <Icon name="Copy" size={16} color="var(--color-muted-foreground)" />
              </button>
            </div>
            <div className="p-6 overflow-x-auto">
              <pre className="text-sm font-mono text-foreground leading-relaxed">
                <code>{snippets[activeSnippet].code}</code>
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CodeSnippetShowcase;